import { IEvent } from "modules/events/domain/models/IEvent";
import {
  ILoginEventParams,
  ILoginEventResponse,
} from "modules/events/domain/models/ILoginEvent";
import { IEventRepository } from "modules/events/domain/interfaces/IEventRepository";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { HttpRepository } from "./_HttpRepository";
import { EventSessionStorage } from "../localStorage/EventSessionStorage";

interface IEnterEventServerResponse extends ILoginEventResponse {
  sessaoPOSId?: string;
  registroSessaoPOSId?: string;
}

export const EventRepository = (): IEventRepository => {
  const httpRepository: IHttpRepository = HttpRepository();
  const eventSessionStorage = EventSessionStorage();

  const getEventsByLocalClienteId = async (
    localClienteId: string
  ): Promise<IEvent[]> => {
    return await httpRepository.getAsync<IEvent[]>(
      `/Event/GetEventByLocalClienteId/${localClienteId}`
    );
  };

  const loginEvent = async (
    params: ILoginEventParams
  ): Promise<ILoginEventResponse> => {
    const query = new URLSearchParams({
      localClienteId: params.localClienteId,
      eventId: params.eventId,
      operadorId: params.operadorId,
      dataEquipamentoUTC: params.dataEquipamentoUTC,
      serial: params.serial,
      version: params.version,
    }).toString();

    const response = await httpRepository.postAsync<
      ILoginEventParams,
      IEnterEventServerResponse
    >(
      `/v2/SessaoPOS/EnterEvent?${query}`,
      undefined as unknown as ILoginEventParams
    );

    if (response.sessaoPOSId && response.registroSessaoPOSId) {
      await eventSessionStorage.saveAsync({
        registroSessaoPOSId: response.registroSessaoPOSId,
        sessionId: response.sessaoPOSId,
      });
    }

    return {
      eventId: response.eventId,
      WorksWithEvents: response.WorksWithEvents ?? false,
    };
  };

  return {
    getEventsByLocalClienteId,
    loginEvent,
  };
};
